import { GearIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const SettingsGear = (props: IconProps) => {
  const { size = 'md', ...rest } = props;

  return <GearIcon {...rest} size={Sizes[size]} />;
};

SettingsGear.displayName = 'SettingsGear';
